"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRegExpString = exports.parseRegExpString = void 0;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#advanced_searching_with_flags
var REGEXP_LITERAL_PATTERN = /^\/(.+)\/([guimysd]*)$/;
var parseRegExpString = function (str) {
    var result = str.match(REGEXP_LITERAL_PATTERN);
    if (!result) {
        return null;
    }
    return {
        source: result[1],
        flagString: result[2]
    };
};
exports.parseRegExpString = parseRegExpString;
var isRegExpString = function (str) {
    return REGEXP_LITERAL_PATTERN.test(str);
};
exports.isRegExpString = isRegExpString;
//# sourceMappingURL=regexp-parse.js.map